import { render, staticRenderFns } from "./CreateDomainDialog.vue?vue&type=template&id=274de6ae&"
import script from "./CreateDomainDialog.vue?vue&type=script&lang=js&"
export * from "./CreateDomainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports